import React from "react";
import {
    WEEKDAYS_SHORT
} from '../../../constants';

const MonthViewCell = (props) => {
  const {
    listItem,
    keyIndex,
    todayDate,
    blockedDates = [],
    blockedDays = [],
  } = props;

  // Map numeric weekday (0–6) → "SUN", "MON", etc.
  const weekdayNames = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  return (
    <div className="fc-bg" key={"monthviewcell" + keyIndex}>
      <table className="">
        <tbody>
          <tr>
            {listItem.map((item, itemIndex) => {
              let classArr = [
                "fc-day",
                "fc-widget-content",
                "fc-" + WEEKDAYS_SHORT[itemIndex],
                "fc-past",
              ];

              if (item.currentMonth === false) {
                classArr.push("fc-other-month");
              }
              // if (
              //   new Date(todayDate).setHours(0, 0, 0, 0) ===
              //   new Date(item.date).setHours(0, 0, 0, 0)
              // ) {
              //   classArr.push("fc-day-today");
              // }
              const isToday =
              new Date(todayDate).setHours(0, 0, 0, 0) ===
              new Date(item.date).setHours(0, 0, 0, 0);

              // 🔹 Check if this date is a holiday
              const holiday = blockedDates.find((b) => b.date === item.c_date);

              // 🔹 Check if this weekday is blocked (convert to "SUN", "MON"...)
              const weekdayName = weekdayNames[new Date(item.date).getDay()];
              const weekdayBlocked = blockedDays.includes(weekdayName);

              let isBlocked = false;
              let reason = "";

              if (holiday) {
                isBlocked = true;
                reason = holiday.reason;
              } else if (weekdayBlocked) {
                isBlocked = true;
                reason = "Clinic Not Available";
              }

              if (isBlocked) {
                classArr.push("fc-day-blocked");
              } else if (isToday) {
                classArr.push("fc-day-today");
              }

              return (
                <td
                  key={itemIndex}
                  className={classArr.join(" ")}
                  style={
                    isBlocked
                      ? {
                          cursor: "not-allowed",
                        }
                      : {}
                  }
                  title={reason}
                  onClick={() => {
                    if (!isBlocked) {
                      props.addVisitToogleHandler({ visit_date: item.c_date });
                    }
                  }}
                ></td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MonthViewCell;